import { Descriptions, Tag } from 'antd';
import dayjs from 'dayjs';
import type { Firm } from '../../../types';
import { MaskedValue } from '../../../components/MaskedValue';

function getLicenseStatusColor(status: string) {
  switch (status) {
    case 'active': return 'green';
    case 'paused': return 'orange';
    case 'expired': return 'red';
    case 'deactivated': return 'default';
    default: return 'default';
  }
}

function getLicenseStatusText(status: string) {
  switch (status) {
    case 'active': return 'Aktif';
    case 'paused': return 'Duraklatıldı';
    case 'expired': return 'Süresi Doldu';
    case 'deactivated': return 'Devre Dışı';
    default: return status;
  }
}

export function GeneralSection({ firm }: { firm: Firm }) {
  return (
    <Descriptions bordered column={2}>
      <Descriptions.Item label="Firma Adı">{firm.name}</Descriptions.Item>
      <Descriptions.Item label="Resmi Adı">{firm.officialName || '-'}</Descriptions.Item>
      <Descriptions.Item label="Subdomain">
        <code>{firm.subdomain}.raporgor.com</code>
      </Descriptions.Item>
      <Descriptions.Item label="Lisans Anahtarı">
        <MaskedValue value={firm.licenseKey} />
      </Descriptions.Item>
      <Descriptions.Item label="Lisans Durumu">
        <Tag color={getLicenseStatusColor(firm.licenseStatus)}>
          {getLicenseStatusText(firm.licenseStatus)}
        </Tag>
      </Descriptions.Item>
      <Descriptions.Item label="Lisans Bitiş">
        {firm.licenseExpiresAt ? dayjs(firm.licenseExpiresAt).format('DD.MM.YYYY') : '-'}
      </Descriptions.Item>
      <Descriptions.Item label="Bayi">{firm.dealerName || 'Doğrudan Müşteri'}</Descriptions.Item>
      <Descriptions.Item label="İletişim E-posta">{firm.contactEmail || '-'}</Descriptions.Item>
      <Descriptions.Item label="Telefon">{firm.phone || '-'}</Descriptions.Item>
      <Descriptions.Item label="Vergi No">{firm.taxNumber || '-'}</Descriptions.Item>
      <Descriptions.Item label="Vergi Dairesi">{firm.taxOffice || '-'}</Descriptions.Item>
      <Descriptions.Item label="Şehir/İlçe">
        {[firm.city, firm.district].filter(Boolean).join(' / ') || '-'}
      </Descriptions.Item>
      <Descriptions.Item label="Adres" span={2}>{firm.address || '-'}</Descriptions.Item>
      <Descriptions.Item label="Notlar" span={2}>{firm.notes || '-'}</Descriptions.Item>
    </Descriptions>
  );
}
